module.exports = __webpack_public_path__ + "img/icon_map_jgdk_c.f811d440.png";